import { useEffect } from "react";
import { useSelector } from "react-redux";
import { IReduxAppState } from "../../../reducers";
import { setFilterState } from "../state/OrderParentActions";
import { OrderTabs } from "../state/OrderParentReducer";
import { useTranslation } from "react-i18next";
import { ICollectionPoint } from "../../ordersSetting/Forms/CollectionPointEntity";

/**Creates the filter critera for orders */
export function useOrdersFilters(dispatch: any, collectionPoints: ICollectionPoint[]) {
    const { t } = useTranslation();

    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);

    const venueSettings = useSelector((state: IReduxAppState) => state.venue[selectedVenueId].venueSettings);

    useEffect(() => {
        async function setFiltersState() {
            const filterState: Record<string, any> = {};
            if (venueSettings?.table_layout && Array.isArray(venueSettings?.table_layout)) {
                filterState[OrderTabs.DINE_IN] = [
                    {
                        key: "table_area",
                        label: "Table Venue Areas",
                        filters: venueSettings?.table_layout?.map((layout) => {
                            return {
                                key: layout.table_range_name,
                                label: layout.table_range_name,
                                param: "table_area",
                                expected: layout.table_range_name
                            }
                        })
                    }
                ]
            }
            if (venueSettings?.pickup_now_enabled) {
                if (collectionPoints &&
                    Array.isArray(collectionPoints) &&
                    collectionPoints.length > 0) {
                    const cPFilters = [];
                    for (const cP of collectionPoints) {
                        if (cP.enabled && !cP.deleted) {
                            cPFilters.push({
                                key: cP.id,
                                label: cP.name,
                                param: "collection_point_id",
                                expected: cP.id
                            });
                        }
                    }
                    filterState[OrderTabs.COLLECTION] = [
                        {
                            key: "collection_points",
                            filters: cPFilters,
                            label: t("misc.collectionPoints"),

                        }
                    ]
                }
            }
            dispatch(setFilterState(filterState));
        }
        setFiltersState();
        // eslint-disable-next-line     
    }, [venueSettings, collectionPoints]);

}